import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { finalize } from 'rxjs/operators';
import { AppService } from '../../services/app.service';
import { Utils } from '../../core/Utils';
import { LessonObservationService } from '../../services/lesson-observation.service';
import { ILessonObservation } from '../../models/LessonObservation';

export type LessonObservationApprovalAction = 'Approve' | 'Reject';

@Component({
    selector: 'app-lesson-observation-approval',
    templateUrl: './approval.component.html'
})
export class LessonObservationApprovalComponent {
    constructor(
        private app: AppService,
        private service: LessonObservationService,
        private activeModal: NgbActiveModal
    ) { }

    @Input() data: ILessonObservation;
    @Input() type: 'promotion' | 'review' = 'review';

    action: LessonObservationApprovalAction;
    comment: string;

    readonly actions: LessonObservationApprovalAction[] = ['Approve', 'Reject'];
    readonly commentMaxLength = 1000;
    readonly getMaxLengthValidationPattern = Utils.getMaxLengthValidationPattern;

    isSaving: boolean;

    get isCommentRequired() {
        return this.action == 'Reject';
    }

    submit() {
        const success = () => {
            this.app.notify(this.app.translate('lessonObservation_reviewed'));
            this.activeModal.close();
        };

        this.isSaving = true;

        const req = this.action == 'Approve'
            ? (this.type == 'promotion' ? this.service.promote(this.data.Id) : this.service.approve(this.data.Id))
            : this.service.reject(this.data.Id, this.comment);

        this.app.addLoading(req, 500).pipe(finalize(() => this.isSaving = false)).subscribe(success);
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
